export const LOCAL_STORAGE_FEATURES_NAME = 'Team Features'
export const SESSION_STORAGE_FEATURES_MIGRATED_KEY = 'Team Features Migrated'

export const parseFeatureKeysFromLocalStorage = () => {
  const serializedFeatures = window.localStorage.getItem(LOCAL_STORAGE_FEATURES_NAME)
  if (!serializedFeatures) return []

  try {
    const featureKeys = JSON.parse(serializedFeatures)
    return Array.isArray(featureKeys) ? featureKeys : []
  } catch (e) {
    return []
  }
}

export const hasUserFeatureIntentKey = (userFeatureIntent, featureKey) => {
  const featureKeys = userFeatureIntent?.feature_keys || userFeatureIntent?.featureKeys
  return Array.isArray(featureKeys) && featureKeys.includes(featureKey)
}
